import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LoadingState } from "@/components/shared";

// Hard onboarding gate: a candidate cannot reach the main workspace until their
// AI profile is confirmed. Sends them to the CV-build flow first.
export function CandidateGate({ children }) {
  const nav = useNavigate();
  const { user } = useAuth();
  const [state, setState] = useState("checking"); // checking | ok | redirecting

  useEffect(() => {
    let alive = true;
    if (user?.invitation_only) { setState("ok"); return; }
    api.get("/profile/me")
      .then((r) => {
        if (!alive) return;
        if (r.data?.status === "confirmed") {
          setState("ok");
        } else {
          setState("redirecting");
          nav("/candidate/profile", { replace: true });
        }
      })
      .catch(() => { if (alive) setState("ok"); }); // fail open — never trap the user
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state !== "ok") return <LoadingState label="Preparing your workspace…" />;
  return children;
}
